import { Layout } from 'antd';
import styled from 'styled-components';

export default styled(Layout)`
	// Add your styles here
`;
